module.exports = __webpack_public_path__ + "static/media/drop2.26013cf3.svg";